import React from 'react';

const SparkIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    focusable="false"
    stroke="currentColor"
    strokeLinecap="round"
    strokeWidth="1.4"
    viewBox="0 0 24 24"
  >
    <path d="M12 2v20M2 12h20M5 5l14 14M5 19 19 5" />
  </svg>
);

export default SparkIcon;
